import { Component, inject } from '@angular/core';

import { MenuDisplayMode } from '@frontend/vanilla/core';
import { MenuItemComponent as vnMenuItemComponent } from '@frontend/vanilla/features/menus';

import { ProductMenuService as LocalProductMenuService } from '../product-menu.service';
import { ProductMenuItemBase } from './product-menu-item-base';

@Component({
    imports: [vnMenuItemComponent],
    selector: 'vn-pm-menu-item',
    templateUrl: 'menu-item.html',
})
export class MenuItemComponent extends ProductMenuItemBase {
    private localProductMenuService = inject(LocalProductMenuService);

    click() {
        if (this.productMenuService.isTab(this.item) && this.item.children) {
            this.productMenuService.openTab(this.item.name);
        } else if (!this.productMenuService.routerMode) {
            this.localProductMenuService.toggle();
        }
    }

    protected readonly MenuDisplayMode = MenuDisplayMode;
}
